import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Gloss } from '@models/Gloss';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GlossContainer } from '@models/GlossContainer';
import { SynchronizerService } from '../../synchronizer.service';
import { ProjectTextStyleDirective } from '../../project-text-style.directive';
import { GlossDialogComponent, GlossDialogInput, GlossDialogOutput } from '../gloss-dialog/gloss-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-gloss-selector-line',
  imports: [CommonModule, MatButtonModule, MatIconModule, ProjectTextStyleDirective],
  templateUrl: './gloss-selector-line.component.html',
  styleUrl: './gloss-selector-line.component.scss'
})
export class GlossSelectorLineComponent {
  @Input() gloss!: Gloss;
  @Input() container!: GlossContainer;
  @Output() action: EventEmitter<GlossDialogOutput> = new EventEmitter<GlossDialogOutput>();

  readonly dialog = inject(MatDialog);

  constructor(public synchronizerService: SynchronizerService) {
    this.synchronizerService = inject(SynchronizerService);
  }

  toggleVote() {
    if (this.synchronizerService.currentUser) {
      const user_id = this.synchronizerService.currentUser.user_id;
      this.gloss.toggleGloss(user_id);
      this.container.setVote(this.gloss, user_id);
      this.container = this.container.copyOf();
    }
  }

  layoutDirectionLtr(): boolean {
    return this.synchronizerService.currentProject?.layout_direction === "ltr";
  }

  editGloss() {
    const data: GlossDialogInput = { type: this.gloss.annotationType, newGloss: false, gloss: this.gloss };
    const dialogRef = this.dialog.open<GlossDialogComponent, GlossDialogInput, GlossDialogOutput>(GlossDialogComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe(async (output) => {
      if (output !== undefined) {
        /// GlossSelector has the functions need to keep everything synced with the verse
        this.action.emit(output);
      }
    });
  }

  get isPowerUser(): boolean {
    if (this.synchronizerService.currentUser && this.synchronizerService.currentProject) {
      return this.synchronizerService.currentProject.isPowerUser(this.synchronizerService.currentUser.user_id);
    }
    return false;
  }

}
